import React, { Fragment } from 'react';
import ServiceOffer from 'Components/EliteServiceOffer';
import ListModel from '../../state/ListModel';
import { ServiceOfferModel } from 'Stores/OfferModel';
import IntroText from 'Components/IntroText';
import styles from 'Plugins/OfferList/styles.scss';

const ServiceOfferList = (props) => {
  const { offerList } = props;
  const offerListModel = new ListModel(offerList, ServiceOfferModel);

  if (offerListModel.items.length === 0) {
    return (
      <IntroText
        headline={{
          level: 'h2',
          value: 'Zurzeit sind keine Angebote vorhanden',
          forceUppercase: true,
        }}
      />
    );
  }

  return offerListModel.items.reduce(
    (acc, offer, i) => [
      ...acc,
      <Fragment key={offer.id}>
        {i > 0 && <div className={styles.separator} />}
        <ServiceOffer {...props} offer={offer} id={`offer-${offer.id}`} />
      </Fragment>,
    ],
    []
  );
};

export default ServiceOfferList;
